import { BlurFade } from "components/magicui/blur-fade";
import { useReducedMotion } from "motion/react";
import type { ReactNode } from "react";

interface FadeInProps {
	children: ReactNode;
	delay?: number;
	className?: string;
}

export function FadeIn({ children, delay = 0, className }: FadeInProps) {
	const reducedMotion = useReducedMotion();

	if (reducedMotion) {
		return <div className={className}>{children}</div>;
	}

	return (
		<BlurFade delay={delay} className={className}>
			{children}
		</BlurFade>
	);
}
